import { Link } from 'react-router-dom'
import { Layers, Mail, Phone, MapPin } from 'lucide-react'
import './Footer.css'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <div className="footer__logo">
              <Layers size={20} />
              <span>NexCore Solutions</span>
            </div>
            <p>Building enterprise-grade software that transforms how businesses manage people, operations, and growth.</p>
            <div className="footer__social">
              <a href="#" aria-label="LinkedIn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
              </a>
              <a href="#" aria-label="X / Twitter">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="#" aria-label="GitHub">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/></svg>
              </a>
            </div>
          </div>

          <div className="footer__col">
            <h4>Products</h4>
            <Link to="/products/human-capital-management">Human Capital Management</Link>
            <Link to="/products/takeaway-system">Takeaway System</Link>
            <Link to="/products/account-management">Account Management</Link>
            <Link to="/products/textile-erp">Textile ERP</Link>
            <Link to="/products/manufacturing-inventory">Manufacturing Inventory</Link>
          </div>

          <div className="footer__col">
            <h4>Company</h4>
            <Link to="/">Home</Link>
            <Link to="/blogs">Blogs</Link>
            <Link to="/contact">Contact Us</Link>
            <Link to="/contact">Get a Demo</Link>
          </div>

          <div className="footer__col">
            <h4>Legal</h4>
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/cookies">Cookie Policy</Link>
          </div>

          <div className="footer__col">
            <h4>Contact</h4>
            <div className="footer__contact-item"><Mail size={14} /><span>hello@nexcoresolutions.com</span></div>
            <div className="footer__contact-item"><Phone size={14} /><span>+91 44 4000 0000</span></div>
            <div className="footer__contact-item"><MapPin size={14} /><span>Chennai, Tamil Nadu, India</span></div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {new Date().getFullYear()} NexCore Solutions Pvt. Ltd. All rights reserved.</p>
          <div className="footer__bottom-links">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/cookies">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
